module.exports = __webpack_public_path__ + "stylesheets/section-horizontal-text-video_ef732b3debfb0a7bb32b5714b9f47a64.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-horizontal-text-video.less
// module id = wwNa
// module chunks = 151